import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { encryptParams, decryptParams } from 'modules/enrollment/api';
import { handleError, startLoading } from 'utils/sliceUtils';

const initialState = {
  activeStep      : 0,
  isLoading       : false,
  params          : null,
  encryptedParams : null,
  uuid            : null,
};

const slice = createSlice({
  name: 'demo',
  initialState,
  reducers: {
    nextStep: (state) => {
      state.activeStep += 1;
    },
    previousStep: (state) => {
      state.activeStep -= 1;
    },
  },
  extraReducers: (builder) => {
    builder
        .addCase(start.fulfilled, (state, action) => {
          state.encryptedParams = action.payload.encryptedParams;
          state.isLoading = false;
          state.activeStep += 1;
        })
        .addCase(decrypt.fulfilled, (state, action) => {
          state.params = action.payload.decrypted;
          state.isLoading = false;
        })
        .addMatcher(
            isAnyOf(
                start.pending,
                decrypt.pending
            ),
            startLoading
        )
        .addMatcher(
            isAnyOf(
                start.rejected,
                decrypt.rejected
            ),
            handleError
        )
  }
});


export const { reducer } = slice;
export const selectDemo = (state) => state.demo;
export const { nextStep, previousStep } = slice.actions;

export const start = createAsyncThunk('@enrollment/start',
    async (params) => {
    const result = await encryptParams(params);
    const encryptedParams = result.resultData;
    return { encryptedParams };
  }
);

export const decrypt = createAsyncThunk('@enrollment/decryptParams',
    async (params) => {
      const decrypted = await decryptParams(params);
      decrypted['uuid'] = params['uuid'];
      return { decrypted };
    }
);
